module.exports = __webpack_public_path__ + "static/labuan-bajo-1742a6d8502a6d2b23b848289b249af9.png";